import axios from 'axios';
import React from 'react';
import * as _ from 'lodash';

import RssFeed from './RssFeed';


export default class RssFeedReader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            feedItems: [{
                title: 'Please Wait',
                description: 'Loading articles...',
                link: '#'
            }]
        };
        this.loadFeed = this.loadFeed.bind(this);
        this.cleanFeed = this.cleanFeed.bind(this);
        this.insertTopContent = this.insertTopContent.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.feedUrl !== prevProps.feedUrl) {
            this.loadFeed();
        }
    }

    componentDidMount() {
        this.loadFeed();
    }

    loadFeed(url = this.props.feedUrl) {
        // Code from https://docs.djangoproject.com/en/3.0/ref/csrf/#ajax
        function getCookie(name) {
            var cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i].trim();
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        }

        var csrftoken = getCookie('csrftoken');
        // End of django code

        axios.post(this.props.endpoint,
          {url: url},
          {headers: {"X-CSRFToken": csrftoken}}
        ).then(response => {
            this.setState({
                feedItems: this.cleanFeed(response.data)
            });
        });
    }

    cleanFeed(feedItems) {
        const cleanFields = ['description'];
        for (let item of feedItems) {
            for (let field of cleanFields) {
                let fieldValue = _.get(item, field, false);
                if (fieldValue) {
                    let valueText = fieldValue.replace(/<(?:.|\n)*?>/gm, '');
                    let unescapedText = _.unescape(valueText);
                    if (this.props.descriptionLength) {
                        unescapedText = unescapedText.substring(0, this.props.descriptionLength) + '...';
                    }
                    item[field] = unescapedText;
                }
            }
        }
        return feedItems;
    }

    /**
     * Insert the HTML that should be displayed above the RSS feed items.
     *
     * @returns {{__html: *}}
     */
    insertTopContent() {
        return {
            __html: this.props.topContent
        };
    }

    render() {
        return (
            <div className="rss-feed-reader">
                <div className="rss-feed-reader__top-content" dangerouslySetInnerHTML={this.insertTopContent()}/>
                <RssFeed entries={this.state.feedItems} showDescription={this.props.showDescription}/>
            </div>
        );
    }

}
